<template>
    <div class="modal-backdrop">
      <div class="card col-lg-4 col-md-8 col-11 p-0 marginper15 mx-auto">
        <div class="modal-content border-0">
          <div class="modal-header">          
            <button type="button" class="close" id="closebtn" @click="closeMeetYourProfileStrengthModal" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body  pb-5">
              <div class="text-center">
                  <div v-if="profileStrengthPercentage>=50">
                    <span v-if="!addedContactInfo" class="proximanova fontsize16 black">Please update your Contact  before applying to this job.</span>
                    <span v-else class="proximanova fontsize16 black">Your experience is not matching with this job position. If you have valid experinece, update your work experince by clicking on below button</span>
                  </div>
                  <div v-else>
                    <span class="proximanova fontsize16 black">Please update required profile information like basic information, contact details, educations & experience details , location & skills before applying to this job.</span>
                  </div>
                  <button class="button-cancel-font backgroundcolorblack mouseoverbtn2 borderradius20 pointer white border  proximanova mt-4 p-1 pl-3 pr-3 mx-auto" @click="NavToEditProfile">Update Work Experience</button>
              </div>
          </div>
        </div>
      </div>
    </div>  
  </template>
  
  <script>
  import router from '../router.js'
  export default{
     data() {
          return{
            addedContactInfo : false,
            profileStrengthPercentage : 0
          }
      },
      methods:{
        closeMeetYourProfileStrengthModal(){
              this.$emit('closeMeetYourProfileStrengthModal')
          },
          NavToEditProfile : function(){
            this.$session.set("activeElement", 'work_exp')
              var btn = document.getElementById('closebtn')
              btn.click()
              router.push({
                  name : 'editprofile'
              })
          }
      },
      mounted() {
        this.addedContactInfo = this.$store.state.addedContactInfo;
        this.profileStrengthPercentage = this.$store.state.profileStrengthPercentage;
      },
  
  }
  
  </script>
  
  <style scoped>
  @import '../css/modal.css';
  </style>